import React, { useEffect } from 'react';
import { useState } from 'react';
import { useCallback } from 'react';
import Spinner from 'sushiweb/Spinner/Spinner';
import GuidelineNode from './GuidelineNode';
import ParentNode from './ParentNode';

const NodeList = ({
  orderId = null,
  allData,
  showGuideLineOpened = false,
  setClickedToHome,
  setShowBack,
  callBack,
  setCallBack,
  nodesLoading = false,
  nodesToRender = [],
  setNodesToRender = () => {},
}) => {
  const [currentNodeParentId, setCurrentNodeParentId] = useState(null);

  useEffect(() => {
    if (!currentNodeParentId) return;
    const backArrowHandler = (parentId) => {
      const nodes = [];
      for (let i = 0; i < allData?.length; i++) {
        const node = allData[i];
        if (node?.id === parentId) {
          nodes.push(node);
        }
      }
      setNodesToRender(nodes);
      setCallBack(false);
    };
    if (callBack) backArrowHandler(currentNodeParentId);
  }, [callBack]);

  const getChildNodesToRender = useCallback(
    (parentId) => {
      const nodes = [];
      for (let i = 0; i < allData?.length; i++) {
        const node = allData[i];
        if (node?.parent_id === parentId) {
          nodes.push(node);
        }
      }
      setNodesToRender(nodes);
      setClickedToHome(false);
      setShowBack(true);
    },
    [allData, setClickedToHome, setNodesToRender, setShowBack],
  );

  if (nodesLoading)
    return (
      <div className='tw-bg-grey-100 tw-py-4 tw-flex tw-items-center tw-justify-center tw-rounded-xl tw-my-4 tw-mx-6 tw-text-300 tw-font-medium'>
        <div className='tw-w-full tw-justify-center tw-items-center tw-p-3'>
          <Spinner />
        </div>
      </div>
    );

  return (
    <div className='tw-flex-col tw-gap-5 tw-px-6 tw-pb-6 '>
      <div className='tw-flex-col tw-gap-5 tw-pt-4 '>
        {nodesToRender?.length === 0 ? (
          <div className='tw-bg-grey-100 tw-py-4 tw-flex tw-items-center tw-justify-center tw-rounded-xl tw-mb-4  tw-text-300 tw-font-medium'>
            No node found !!
          </div>
        ) : null}
        {nodesToRender.map((node, ind) => {
          let CompName = null;
          CompName =
            node?.node_type != 'guideline' ? ParentNode : GuidelineNode;
          return (
            <CompName
              key={`nodesToRender_${ind}`}
              orderId={orderId}
              node={node}
              getChildNodesToRender={getChildNodesToRender}
              setCurrentNodeParentId={setCurrentNodeParentId}
              callBack={callBack}
              setShowBack={setShowBack}
              isDefaultOpen={showGuideLineOpened && ind === 0}
            />
          );
        })}
      </div>
    </div>
  );
};

export default NodeList;
